import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * The close action for a record page: history back when the page was reached
 * in-app, or a replace to `fallbackPath` when it was the first entry (a pasted
 * link, a reload). react-router marks the first entry with `location.key ===
 * 'default'`; going back from there would leave the app.
 *
 * @returns The close callback; stable while `fallbackPath` and the entry kind hold.
 */
export function useCloseRecord(fallbackPath: string): () => void {
  const navigate = useNavigate();
  const location = useLocation();
  const isFirstEntry = location.key === 'default';

  return React.useCallback(() => {
    if (isFirstEntry) {
      void navigate(fallbackPath, { replace: true });
      return;
    }
    void navigate(-1);
  }, [fallbackPath, isFirstEntry, navigate]);
}
